import { useCompanyBankDetailListQuery } from "Company/Modules/BankDetail/Api/Query/useCompanyBankDetailListQuery";
import { BankDetailEditCard } from "Company/Modules/BankDetail/Components/BankDetailEditCard";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Loading } from "Shared/Components/Loading/Loading";
import { Grid2, Stack } from "@mui/material";
import type { FC } from "react";
import { BankDetailCreateCard } from "../Components/BankDetailCreateCard";

type Props = {
	companyId: number;
};

const bankDetailResources = Resources.base.bankDetail.shared;

export const BankDetailWidget: FC<Props> = ({ companyId }) => {
	const { t } = useResource();
	const { data: bankDetails, isLoading } =
		useCompanyBankDetailListQuery(companyId);

	return (
		<BaseCard title={t(bankDetailResources.bankDetails)}>
			{isLoading ? (
				<Stack alignItems="center">
					<Loading />
				</Stack>
			) : (
				<></>
			)}
			<Grid2 container spacing={2}>
				<Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
					<BankDetailCreateCard companyId={companyId} />
				</Grid2>
				{bankDetails?.map((bankDetail) => (
					<Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={bankDetail.id}>
						<BankDetailEditCard bankDetail={bankDetail} companyId={companyId} />
					</Grid2>
				))}
			</Grid2>
		</BaseCard>
	);
};
